const separator = {
  template: `<hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">`,
};

const data = [
  {
    header: true,
    title: "JC Steele",
  },
  {
    href: "/admin",
    title: "Dashboard",
    icon: "fa fa-home",
  },
  {
    header: true,
    title: "Usage",
  },
  {
    title: "Machines",
    icon: "fa fa-wrench",
    href: "/admin/machines",
  },
  {
    title: "Machine Imports",
    icon: "fa fa-file-import",
    href: "/admin/import",
  },
  {
    title: "Assembly",
    icon: "fa fa-wrench",
    href: "/admin/assembly",
  },
  {
    title: "Sub Assemblies",
    icon: "fa fa-wrench",
    href: "/admin/subassembly",
  },
  {
    title: "Parts",
    icon: "fa fa-cog",
    href: "/admin/parts",
  },
  {
    title: "Wear Parts",
    icon: "fa fa-cog",
    href: "/admin/wear",
  },
  {
    title: "Company Discounts",
    icon: "fa fa-building",
    href: "/admin/company/discounts",
  },
  {
    title: "Sequence",
    icon: "fa fa-cog",
    href: "/admin/sequence",
  },
  {
    title: "Company Items",
    icon: "fa fa-building",
    child: [
      {
        href: "/admin/company",
        title: "Company Listing",
      },
      {
        href: "/admin/company/machines",
        title: "Company Machine Listings",
      },
    ],
  },
  {
    title: "Users",
    icon: "fa fa-user",
    href: "/admin/users",
  },
  {
    header: true,
    component: separator,
    visibleOnCollapse: true,
  },
  {
    header: true,
    title: "Settings",
  },
  {
    title: "Email Management",
    icon: "fa fa-envelope",
    href: "/admin/emailmanagement",
  },
  {
    title: "Content Block",
    icon: "fa fa-list-alt",
    href: "/admin/contentblocks",
  },
  {
    title: "Pages",
    icon: "fa fa-list-alt",
    href: "/admin/pages",
  },
  {
    title: "Settings",
    icon: "fa fa-building",
    child: [
      {
        href: "/admin/settings",
        title: "Global Settings",
      },
      {
        href: "/admin/settings/companysettings",
        title: "Company Settings",
      },
    ],
  },
  {
    title: "Navigation",
    icon: "fa fa-list-ul",
    href: "/admin/navigation",
  },
  {
    title: "Error Log",
    icon: "fa fa-bug",
    href: "/admin/errors",
  },
];
export default data;
